module.exports = __webpack_public_path__ + "static/media/switch.dae03d4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/components/dropdown/switch.svg
// module id = 367
// module chunks = 0